import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkFlowEnhancementsCard from './BkFlowEnhancementsCard'
import BkFlowEnhancementsAccordion from '../BkFlowEnhancementsAccordion'
import BkFlowError from '../../elements/BkFlowError'

import _ from 'lodash'
import yn from 'yn'

import getCurrencySymbol from '../../../utilities/currency/getCurrencySymbol'

class BkFlowEnhancementsCards extends Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {
    const {
      configData,
      activeEnhancementData,
      enhancementData,
      activeCurrencyData,
      restaurantData,
      availabilityData,
      activeRoom,
    } = this.props

    const hotelLabels = configData.hotel.labels[0],
          activeRoomsAmount = Object.keys(activeRoom).length

    let enhancementGroups = []

    for (let roomGroupKey in activeRoom) {
      let currencyCode = null,
          currencySymbol = null,
          enhancementCardType = null,
          enhancementCards = [],
          accordionEnhancementCards = [],
          hasRestaurants = false

      if (
        yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
        activeCurrencyData &&
        activeCurrencyData.exchangeRate &&
        activeCurrencyData.currencyCode
      ) {
        currencyCode = activeCurrencyData.currencyCode

        if (activeCurrencyData.currencySymbol) {
          currencySymbol = activeCurrencyData.currencySymbol
        } else {
          currencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
        }
      } else if (
        activeRoom[roomGroupKey] &&
        _.get(activeRoom[roomGroupKey], '[1][0].rates[0].total.currencyCode')
      ) {
        currencyCode = activeRoom[roomGroupKey][1][0].rates[0].total.currencyCode
        currencySymbol = getCurrencySymbol(currencyCode)
      }

      // Check for enhancements data for specific room group / rate key
      if (
        enhancementData.enhancements &&
        enhancementData.enhancements[activeRoom[roomGroupKey][0][0].roomTypeCode + '-' + activeRoom[roomGroupKey][1][0].ratePlanCode + '-' + roomGroupKey]
      ) {
        enhancementCardType = enhancementData.enhancements[activeRoom[roomGroupKey][0][0].roomTypeCode + '-' + activeRoom[roomGroupKey][1][0].ratePlanCode + '-' + roomGroupKey]
      }

      // Set hasRestaurants if reservations feature enabled and valid restaurants exist
      if (
        yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS) &&
        restaurantData.restaurants &&
        restaurantData.restaurants[activeRoom[roomGroupKey][0][0].roomTypeCode + '-' + activeRoom[roomGroupKey][1][0].ratePlanCode + '-' + roomGroupKey]
      ) {
        hasRestaurants = true
      }

      let visibleEnhancements = 2

      if (Number(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_PAGINATION_THRESHOLD) > 0) {
        visibleEnhancements = Number(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_PAGINATION_THRESHOLD)
      }

      // Construct cards, groups and accordions if data meets requirements
      if (!_.isEmpty(enhancementCardType)) {
        for (let enhancementKey in enhancementCardType) {
          if (
            enhancementCardType[enhancementKey].serviceInventoryCode &&
            enhancementCardType[enhancementKey].price &&
            enhancementCardType[enhancementKey].serviceDetails &&
            enhancementCardType[enhancementKey].serviceDetails.comments
          ) {
            // Push first 3 cards on to page in columns and remainder into an accordion
            if (enhancementKey <= visibleEnhancements) {
              enhancementCards.push(
                <BkFlowEnhancementsCard
                  key={ 'enhancement-' + roomGroupKey + '-' + enhancementKey}
                  configData={ configData }
                  enhancementCardType={ enhancementCardType }
                  enhancementKey={ enhancementKey }
                  roomGroupKey={ roomGroupKey }
                  activeCurrencyData={activeCurrencyData}
                  currencySymbol={ currencySymbol }
                  currencyCode={ currencyCode }
                  activeRoom={ activeRoom }
                  activeEnhancementData={activeEnhancementData}
                />
              )
            } else {
              accordionEnhancementCards.push(
                <BkFlowEnhancementsCard
                  key={ 'enhancement-' + roomGroupKey + '-' + enhancementKey}
                  configData={ configData }
                  enhancementCardType={ enhancementCardType }
                  enhancementKey={ enhancementKey }
                  roomGroupKey={ roomGroupKey }
                  activeCurrencyData={activeCurrencyData}
                  currencySymbol={ currencySymbol }
                  currencyCode={ currencyCode }
                  activeRoom={ activeRoom }
                  activeEnhancementData={activeEnhancementData}
                />
              )
            }
          }
        }
      } else if (!hasRestaurants) {
        enhancementCards.push(
          <BkFlowError
            key={0}
            configData={configData}
            availabilityData={availabilityData}
            parentClasses="bk-flow-enhancements__empty-results col-xs"
            errorMessage="There are currently no active add ons for this room type and rate."
          />
        )
      }

      // Construct enhancement groups with title, cards and accordion
      enhancementGroups.push(
        <div
          key={roomGroupKey}
          className="bk-flow-enhancements__group row center-xs"
        >
          {
            activeRoomsAmount > 1 &&
            _.get(activeRoom[roomGroupKey], '[0][0].roomDescription.name') &&
              <div className="bk-flow-enhancements__heading row center-xs">
                <h4>{activeRoom[roomGroupKey][0][0].roomDescription.name + ' ' + hotelLabels.enhancements}</h4>
              </div>
          }

          { enhancementCards }

          {!_.isEmpty(accordionEnhancementCards) &&
            <BkFlowEnhancementsAccordion
              accordionEnhancementCards={accordionEnhancementCards}
            />
          }
        </div>
      )
    }

    // Render all enhancement groups with cards or generic no-avail response
    return enhancementGroups
  }
}

function mapStateToProps(state) {
  return {
    configData: state.configData.configuration,
    enhancementData: state.enhancementData,
    activeEnhancementData: state.activeEnhancementData,
    restaurantData: state.restaurantData,
    availabilityData: state.availabilityData,
    activeRoom: state.activeRoomData,
    activeCurrencyData: state.activeCurrencyData,
  }
}

export default connect(mapStateToProps, null)(BkFlowEnhancementsCards)



// WEBPACK FOOTER //
// ./src/components/enhancements/elements/BkFlowEnhancementsCards.js